module.exports = __webpack_public_path__ + "static/img/04.0ba19b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/image/index/04.png
// module id = i/Dd
// module chunks = 1